import { ChangeEvent, useEffect, useState } from "react";
import { classNames, useIsMounted } from "@ct-react/core";
import "./checkbox.scss";

type Props = {
  className?: string;
  id: string;
  label?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

const CheckboxInput = (
  {
    className,
    id,
    label,
    checked: propsChecked,
    onChange = () => void 0
  }: Props) => {

  const isMounted = useIsMounted();
  const [ checked, setChecked ] = useState<boolean>(propsChecked);

  useEffect(() => {
    if (!isMounted) return;
    setChecked(propsChecked);
  }, [ propsChecked ]);

  const onToggle = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    onChange(e.target.checked);
  }
  const wrapperClasses = classNames("cc-checkbox", className);

  return (
    <>
      <label className={wrapperClasses}>
        <input type="checkbox"
               id={id}
               checked={checked}
               onChange={onToggle} />
        <span className="cc-box-mark" />
      </label>
      {!!label &&
        <label htmlFor={id}>{label}</label>
      }
    </>);

}

export default CheckboxInput;
